import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist';
import * as fb from '../firebase'
import router from '../router/router'
import {GoogleAuthProvider, signInWithPopup} from "firebase/auth";
import {auth} from "../firebase";
import User from "../models/User";
import Session from "../models/Session";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage || {},
});



const store = new Vuex.Store({
  state: {
    properties: [],
    show_mobile_menu: false,
  },
  getters: {
    properties: (state) => state.properties,
    show_mobile_menu: (state) => state.show_mobile_menu
  },
  mutations: {
    setProperties(state, val) {
      state.properties = val;
    },
    setShowMobileMenu(state, val){
      state.show_mobile_menu = val;
    }
  },


  actions: {

    toggleMobileMenu({commit, getters}){
      commit('setShowMobileMenu', !getters.show_mobile_menu);
    },
    closeMobileMenu({commit, getters}){
      console.log("close menu");
      commit('setShowMobileMenu', false);
    },
    async gmailSignIn({dispatch}){
      let result = await signInWithPopup(auth, new GoogleAuthProvider());
      console.log('result', result)
      await User.saveUser(result.user, GoogleAuthProvider.credentialFromResult(result));
      const token = await auth.currentUser.getIdTokenResult();

      if (token.claims.admin) { // User is admin
        await router.push('/admin');
        return;
      }

      // Wait for custom claims to be updated.
      let unsubscribe = Session.onDocumentUpdate(token.claims.user_id, session => {
        auth.currentUser.getIdTokenResult(true).then((tokenResult) => {
            if (tokenResult.claims.admin) { // User is admin
              unsubscribe();
              router.push('/admin')
            }
        });
      });
    },
  }
});

export default store
